const reactComponents = {
  "leftmenu/index": require("lib/components/leftmenu/index"),
  "tree/tree": require("lib/components/tree/tree"),
  "CopyableAssessments/index": require("lib/components/CopyableAssessments/index"),
  "passwordmanager/index": require("lib/components/passwordmanager/index"),
  "passwordmanager/new": require("lib/components/passwordmanager/new"),
  "MyCoursesCardView/index": require("lib/components/MyCoursesCardView/index"),
  "UnitInformation/index": require("lib/components/UnitInformation/index"),
  "navtree/index": require("lib/components/navtree/index"),
  "EducationHistory/index": require("lib/components/EducationHistory/index"),
  "Edu/surveytracking": require("lib/components/Edu/surveytracking"),
  "Edu/surveytrackingoverview": require("lib/components/Edu/surveytrackingoverview"),
  "Checklist/indexPortal": require("lib/components/Checklist/indexPortal"),
  "Checklist/indexAdmin": require("lib/components/Checklist/indexAdmin"),
  Rating: require("lib/components/Rating/index"),
  RatingComments: require("lib/components/Rating/ratingComments"),
  "Share/index": require("lib/components/Share/index"),
  "RecommendedLearningActivities/index": require("lib/components/RecommendedLearningActivities/index"),
  CookieConsent: require("lib/components/CookieConsent/index.jsx"),
  "help/index.jsx": require("lib/components/help/index.jsx"),
  SessionExpiration: require("lib/components/SessionExpiration/index.jsx"),
};

import componentRegister from "./react-component-register";

luvit.registerReact = () => {
  Object.keys(reactComponents).forEach((c) =>
    componentRegister(c, reactComponents[c]),
  );
};

luvit.registerReact();

require("./coursemenu");
